import LoginPage from '@/pages/public/LoginPage'
import { RouteObject } from 'react-router-dom'
import ForgotPasswordPage from '@/pages/public/ForgotPasswordPage'
import ResetPasswordPage from '@/pages/public/ResetPasswordPage'
import PublicRouteTemplate from '@/components/templates/PublicRouteTemplate'
import SignUpPage from '@/pages/public/SignUpPage'
import VerifyEmailPage from '@/pages/public/VerifyEmailPage'
import VerifyEmailChangePage from '@/pages/public/VerifyEmailChangePage'
import AcceptInvitePage from '@/pages/public/AcceptInvitePage'

export const publicRoutes: RouteObject[] = [
  {
    element: <PublicRouteTemplate />,
    children: [
      {
        path: '/',
        element: <LoginPage />,
      },
      {
        path: '/forgot-password',
        element: <ForgotPasswordPage />,
      },
      {
        path: '/reset-password',
        element: <ResetPasswordPage />,
      },
      {
        path: '/signup',
        element: <SignUpPage />,
      },
      {
        path: '/verify-email',
        element: <VerifyEmailPage />,
      },
      {
        path: '/verify-email-change',
        element: <VerifyEmailChangePage />,
      },
      {
        path: '/accept-invite',
        element: <AcceptInvitePage />,
      },
    ],
  },
]
